"use strict";

var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/workspace/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/workspace/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.default = void 0;

var _ethers = require("ethers"),
    _defaults = require("../../defaults"); // From: https://github.com/danfinlay/eth-method-registry


var REGISTRY_LOOKUP_ABI = ["function entries(bytes4) public view returns (string)"],
    REGISTRY_MAP = {
  1: "0x44691B39d1a75dC4E0A0346CBB15E310e6ED1E86"
}; // networkId -> registry address

var MethodRegistry =
/*#__PURE__*/
function () {
  function MethodRegistry() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, MethodRegistry);

    this.provider = opts.provider || new _ethers.ethers.providers.WebSocketProvider(_defaults.DEFAULT_ETH_NODE), this.registryAddres = opts.registry || REGISTRY_MAP[opts.network];
  }

  _createClass(MethodRegistry, [{
    key: "initRegistry",
    value: function () {
      var _initRegistry = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.registryAddres) {
                  _context.next = 2;
                  break;
                }

                throw new Error("No method registry found for the network.");

              case 2:
                this.registry = new _ethers.ethers.Contract(this.registryAddres, REGISTRY_LOOKUP_ABI, this.provider);

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function initRegistry() {
        return _initRegistry.apply(this, arguments);
      }

      return initRegistry;
    }()
  }, {
    key: "lookup",
    value: function () {
      var _lookup = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(sigBytes) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = this.registry;

                if (_context2.t0) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.initRegistry();

              case 4:
                return _context2.abrupt("return", this.registry.entries(sigBytes));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function lookup(_x) {
        return _lookup.apply(this, arguments);
      }

      return lookup;
    }()
  }]);

  return MethodRegistry;
}();

exports.default = MethodRegistry;